import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {},
  headline: {
    color: theme.palette.secondary.light,
    marginBottom: theme.spacing(6),
  },
  container: {
    boxShadow: '0px 4px 36px rgba(0, 10, 22, 0.15)',
    borderRadius: '8px !important',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    '&:before': {
      backgroundColor: 'transparent !important',
    },
  },
  summary: {
    fontWeight: 700,
    fontSize: theme.spacing(2),
    color: theme.palette.text.primary,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '&:focus': {
      outline: 'none',
    },
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '&>div>div': {
      marginTop: `${theme.spacing(2)}px !important`,
      marginBottom: `${theme.spacing(2)}px !important`,
    },
    '&>div>div:nth-child(1)': {
      marginTop: '0 !important',
    },
    '&>div>ul': {
      margin: '0 !important',
      '&>li': {
        marginBottom: '8px !important',
        '&>div': {
          marginBottom: '0px !important',
        },
        '&:before': {
          backgroundColor: theme.palette.text.primary,
        },
      },
    },
  },
  ctaButton: {
    paddingLeft: 0,
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      lineHeight: '1rem',
      marginBottom: theme.spacing(1),
    },
  },
}))

export default useStyles
